import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";

import { WirelessSubscriptionListQueryQuery } from "../../apis/networkdashboard/graphql/graphql";
import { LoaderComponent } from "../../components/common/loader/loader";
import { WirelessTicket } from "../../components/models/wireless-ticket";
import { WirelessElement } from "../../components/subscriptions-list/wireless-element/wireless-element";
import { LoadingState } from "../../services/loading-state";

export type WirelessListItem = WirelessSubscriptionListQueryQuery["subscriptions"]["page"][number];

@Component({
  selector: "wireless-subscriptions-results",
  templateUrl: "wireless-subscriptions-results.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoaderComponent, WirelessElement],
})
export class WirelessSubscriptionsResultsComponent {
  protected loadingState = inject(LoadingState);

  subscriptions = input.required<WirelessListItem[]>();
  tickets = input<WirelessTicket[]>([]);
}
